const modal = document.querySelector('#UserStoryViewerModal');
const modelViewer = modal?.querySelector('#modelViewer');

const wrapperViewer = document.querySelector('.wrapper-viewer');
if (wrapperViewer) wrapperViewer.classList.add('modal-sp');

// Fullscreen image
function getViewerAssets() {
  const el = document.getElementById('viewerAssets');
  if (!el) return null;
  try {
    return JSON.parse(el.textContent);
  } catch (e) {
    return null;
  }
}

// update svg
function drawLine(svgLine, dotHotspot1, dotHotspot2, dimensionHotspot) {
  if (!svgLine || !dotHotspot1 || !dotHotspot2) return;

  svgLine.setAttribute('x1', dotHotspot1.canvasPosition.x);
  svgLine.setAttribute('y1', dotHotspot1.canvasPosition.y);
  svgLine.setAttribute('x2', dotHotspot2.canvasPosition.x);
  svgLine.setAttribute('y2', dotHotspot2.canvasPosition.y);

  if (dimensionHotspot && !dimensionHotspot.facingCamera) {
    svgLine.classList.add('hide');
  } else {
    svgLine.classList.remove('hide');
  }
}

// model-viewerで初めに読み込まれる属性を設定する（FourとTwoなどの違い）

// 商品名の登録（通常表示・フルスクリーン両対応）
const textProductName = document.querySelectorAll('.product-name');
setProductName(modelViewer);

let onCameraChangeBound = null;

const dimLines = modelViewer.querySelectorAll('line');

// 寸法線を引く 同時に寸法線の表示非表示の設定
const renderSVG = () => {
  // 寸法線 W 奥
  drawLine(
    dimLines[0],
    modelViewer.queryHotspot('hotspot-dot-X-Y-Z+OFFSET-Z'), // 8B
    modelViewer.queryHotspot('hotspot-dot+X-Y-Z+OFFSET-Z'), // 3B
    modelViewer.queryHotspot('hotspot-dim-Y+Z') // W中央 下 手前
  );
  // 寸法線 W 手前
  drawLine(
    dimLines[1],
    modelViewer.queryHotspot('hotspot-dot-X-Y+Z+OFFSET+Z'), // 2B
    modelViewer.queryHotspot('hotspot-dot+X-Y+Z+OFFSET+Z'), // 5B
    modelViewer.queryHotspot('hotspot-dim-Y-Z') // W中央 下 手前
  );
  // 寸法線 H 左
  drawLine(
    dimLines[2],
    modelViewer.queryHotspot('hotspot-dot-X+Y-Z+OFFSET-Z'), // 6B
    modelViewer.queryHotspot('hotspot-dot-X-Y-Z+OFFSET-Z'), // 8B
    modelViewer.queryHotspot('hotspot-dim-X-Z') // 左 H中央 手前
  );
  // 寸法線 H 右
  drawLine(
    dimLines[3],
    modelViewer.queryHotspot('hotspot-dot+X+Y-Z+OFFSET-Z'), // 1B
    modelViewer.queryHotspot('hotspot-dot+X-Y-Z+OFFSET-Z'), // 3B
    modelViewer.queryHotspot('hotspot-dim+X-Z') // H中央 右 手前
  );
  // 寸法線 D 左
  drawLine(
    dimLines[4],
    modelViewer.queryHotspot('hotspot-dot-X-Y+Z+OFFSET-X'), // 2A
    modelViewer.queryHotspot('hotspot-dot-X-Y-Z+OFFSET-X'), // 8A
    modelViewer.queryHotspot('hotspot-dim-X-Y') // 左 下 D中央
  );
  // 寸法線 D 右
  drawLine(
    dimLines[5],
    modelViewer.queryHotspot('hotspot-dot+X-Y+Z+OFFSET+X'), // 5A
    modelViewer.queryHotspot('hotspot-dot+X-Y-Z+OFFSET+X'), // 3A
    modelViewer.queryHotspot('hotspot-dim+X-Y') // 左 下 D中央
  );
  // 寸法線 H T字 左
  drawLine(
    dimLines[6],
    modelViewer.queryHotspot('hotspot-dot-X+Y-Z+OFFSET-Z+T'), // 6BT-1
    modelViewer.queryHotspot('hotspot-dot-X+Y-Z+OFFSET-Z-T'), // 6BT-2
    modelViewer.queryHotspot('hotspot-dim-X-Z') // 左 H中央 手前
  );
  // 寸法線 H T字 右
  drawLine(
    dimLines[7],
    modelViewer.queryHotspot('hotspot-dot+X+Y-Z+OFFSET-Z+T'), // 1BT-1
    modelViewer.queryHotspot('hotspot-dot+X+Y-Z+OFFSET-Z-T'), // 1BT-2
    modelViewer.queryHotspot('hotspot-dim+X-Z') //
  );
  // 寸法線 W 前 T字 左
  drawLine(
    dimLines[8],
    modelViewer.queryHotspot('hotspot-dot-X-Y+Z+OFFSET+Z+T'), // 2BT-1
    modelViewer.queryHotspot('hotspot-dot-X-Y+Z+OFFSET+Z-T'), // 2BT-2
    modelViewer.queryHotspot('hotspot-dim-Y-Z') //
  );
  // 寸法線 W 前 T字 右
  drawLine(
    dimLines[9],
    modelViewer.queryHotspot('hotspot-dot+X-Y+Z+OFFSET+Z-T'), // 5BT-1
    modelViewer.queryHotspot('hotspot-dot+X-Y+Z+OFFSET+Z+T'), // 5BT-2
    modelViewer.queryHotspot('hotspot-dim-Y-Z') //
  );
  // 寸法線 W 奥 T字 左
  drawLine(
    dimLines[10],
    modelViewer.queryHotspot('hotspot-dot+X-Y-Z+OFFSET-Z-T'), // 3BT-1
    modelViewer.queryHotspot('hotspot-dot+X-Y-Z+OFFSET-Z+T'), // 3BT-2
    modelViewer.queryHotspot('hotspot-dim-Y+Z') //
  );
  // 寸法線 W 奥 T字 右
  drawLine(
    dimLines[11],
    modelViewer.queryHotspot('hotspot-dot-X-Y-Z+OFFSET+Z+T'), // 8BT-1
    modelViewer.queryHotspot('hotspot-dot-X-Y-Z+OFFSET+Z-T'), // 8BT-2
    modelViewer.queryHotspot('hotspot-dim-X-Z') //
  );
  // 寸法線 D 右 T字 奥
  drawLine(
    dimLines[12],
    modelViewer.queryHotspot('hotspot-dot+X-Y-Z+OFFSET+X-T'), // 3AT-1
    modelViewer.queryHotspot('hotspot-dot+X-Y-Z+OFFSET+X+T'), // 3AT-2
    modelViewer.queryHotspot('hotspot-dim+X-Y') //
  );
  // 寸法線 D 右 T字 前
  drawLine(
    dimLines[13],
    modelViewer.queryHotspot('hotspot-dot+X-Y+Z+OFFSET+X-T'), // 5AT-1
    modelViewer.queryHotspot('hotspot-dot+X-Y+Z+OFFSET+X+T'), // 5AT-2
    modelViewer.queryHotspot('hotspot-dim+X-Y') //
  );
  // 寸法線 D 左 T字 奥
  drawLine(
    dimLines[14],
    modelViewer.queryHotspot('hotspot-dot-X-Y-Z+OFFSET-X-T'), // 8AT-1
    modelViewer.queryHotspot('hotspot-dot-X-Y-Z+OFFSET-X+T'), // 8AT-2
    modelViewer.queryHotspot('hotspot-dim-X-Y') //
  );
  // 寸法線 D 左 T字 前
  drawLine(
    dimLines[15],
    modelViewer.queryHotspot('hotspot-dot-X-Y+Z+OFFSET-X-T'), // 2AT-1
    modelViewer.queryHotspot('hotspot-dot-X-Y+Z+OFFSET-X+T'), // 2AT-2
    modelViewer.queryHotspot('hotspot-dim-X-Y') //
  );
  // 寸法線 H 奥 T字 下
  drawLine(
    dimLines[16],
    modelViewer.queryHotspot('hotspot-dot+X-Y-Z+OFFSET-Z-T'), // 3BT-1
    modelViewer.queryHotspot('hotspot-dot+X-Y-Z+OFFSET-Z+T'), // 3BT-2
    modelViewer.queryHotspot('hotspot-dim+X-Z') //
  );
  // 寸法線 H 奥 T字 下
  drawLine(
    dimLines[17],
    modelViewer.queryHotspot('hotspot-dot-X-Y-Z+OFFSET+Z+T'), // 8BT-1
    modelViewer.queryHotspot('hotspot-dot-X-Y-Z+OFFSET+Z-T'), // 8BT-2
    modelViewer.queryHotspot('hotspot-dim-Y+Z') //
  );
};

// -------------------- 🔴ローディング要素 --------------------

// Progress Bar
const progressBar = modal?.querySelector('.progress-bar');

// Overlay
const overlay = modal?.querySelector('.overlay');

// -------------------- 🔴各種ボタン要素 --------------------

// ボタン一式
const wrapperButton = document.querySelector('.wrapper-button');
const wrapperButtonOption = document.querySelector('.wrapper-button-option');

// AR ボタン
const btnAR = document.querySelector('.viewer-ui-ar');

// Fullscreen ボタン
const btnFullscreen = document.querySelector(
  '.wrapper-button-option .viewer-ui-fullscreen'
);

// Dimensions ボタン
const btnDimensions = document.querySelector('.viewer-ui-dimensions');

// Open ボタン
const btnOpen = document.querySelector('.viewer-ui-open');

// Hide ボタン
const btnHide = document.querySelector('.viewer-ui-hide');

// Refresh ボタン
const btnRefresh = document.querySelector('.viewer-ui-refresh');

// Close ボタン
const btnClose = modal.querySelector('.viewer-ui-close');

// -------------------- 🔴各種ボタン付加要素 --------------------

// Fullscreen ボタン 付加要素
const btnFullscreenIcon = document.querySelector(
  '.wrapper-button-option .viewer-ui-fullscreen .material-symbols-outlined'
);
const btnFullscreenExit = btnFullscreen.querySelector('.ui-circle img');
const defaultFullscreenIconSrc = btnFullscreenExit?.getAttribute('src') || '';

// Dimensions ボタン 付加要素
const btnDimensionsActive = document.querySelector(
  '.viewer-ui-dimensions .ui-circle'
);

// Open Flap ボタン 付加要素
const btnOpenText = document.querySelector('.state-open');
const btnOpenActive = document.querySelector('.viewer-ui-open .ui-circle');

// Open Flap ボタン 付加要素
const btnOpenIconOn = document.querySelector('.toggle-open.default');
const btnOpenIconOff = document.querySelector('.toggle-open.active');

// Hide Flap ボタン 付加要素
const btnHideText = document.querySelector('.state-hide');
const btnHideActive = document.querySelector('.viewer-ui-hide .ui-circle');

// Hide Flap ボタン 付加要素
const btnHideIconOn = document.querySelector('.toggle-hide.default');
const btnHideIconOff = document.querySelector('.toggle-hide.active');

// -------------------- 🔴model-viewer 内要素 --------------------

// Dimensions 要素一式
const dimElements = [
  ...modelViewer.querySelectorAll('.button'),
  modelViewer.querySelector('#dimLines'),
];
// Dimensions 寸法要素
const dim = document.querySelectorAll('.dim');
// Dimensions 線のコンテナ
const dimensionLineContainer = modelViewer.querySelector(
  '.dimensionLineContainer'
);

let hasInitialLoaded = false;

// -------------------- 🔴カラーコード(#RGB)を model-viewer用の配列 [r, g, b, 1] に変換する関数 --------------------
// 色変更用に設定
function hexToRgba(hex) {
  // #があれば取り除く
  hex = hex.replace('#', '');

  // 16進数を10進数(0-255)に戻して、255で割って0-1にする
  const r = parseInt(hex.substring(0, 2), 16) / 255;
  const g = parseInt(hex.substring(2, 4), 16) / 255;
  const b = parseInt(hex.substring(4, 6), 16) / 255;

  return [r, g, b, 1.0];
}

document.addEventListener('DOMContentLoaded', (event) => {
  // もしモデルが見つからなかったら、ここで処理を終わらせる
  if (!modelViewer) return;

  // -------------------- ✅ AR / Fullscreen 表示制御（一本化） --------------------
  function applyARUI() {
    const canAR = !!modelViewer.canActivateAR;

    // Closeボタンは常に出すならここ
    if (btnClose) btnClose.style.display = 'flex';

    if (canAR) {
      // AR対応端末（実機スマホなど）
      wrapperViewer?.classList.add('modal-sp');
      if (btnAR) btnAR.style.display = 'flex';
      if (btnFullscreen) btnFullscreen.style.display = 'none';
      modelViewer.setAttribute('touch-action', 'none');
    } else {
      // AR非対応（PCやAR非対応端末）
      wrapperViewer?.classList.remove('modal-sp');
      if (btnAR) btnAR.style.display = 'none';
      if (btnFullscreen) btnFullscreen.style.display = 'flex';
      modelViewer.setAttribute('touch-action', 'pan-y');
    }
  }

  // ✅ Four / Two で camera-target を切り替える
  const cameraTargetTwo = '0m 0.4m 0m';
  const cameraTargetFour = '0m 0.73m 0m';

  function applyCameraTargetBySrc(src) {
    const fileName = String(src || '');

    const nextTarget = fileName.includes('Four')
      ? cameraTargetFour
      : cameraTargetTwo;

    console.log(
      '[camera-target]',
      fileName.includes('Four') ? 'Four' : 'Two',
      nextTarget,
      fileName
    );

    // camera-targetをセット
    modelViewer.setAttribute('camera-target', nextTarget);
    modelViewer.cameraTarget = nextTarget;
  }

  // ✅ GLB load 後が一番確実なのでここでもう一回
  modelViewer.addEventListener('load', applyARUI);

  // <model-viewer>で設定した初期値を保存
  let initial = null;

  function captureInitialForCurrentModel() {
    initial = {
      cameraOrbit: modelViewer.getAttribute('camera-orbit'),
      maxCameraOrbit: modelViewer.getAttribute('max-camera-orbit'),
      cameraTarget: modelViewer.getAttribute('camera-target'),
      fieldOfView: modelViewer.getAttribute('field-of-view'),
      animationName: modelViewer.getAttribute('animation-name'),
      src: modelViewer.src || modelViewer.getAttribute('src') || '',
    };
  }

  // -------------------- 🔴model-viewer のカメラ属性の初期設定 --------------------

  // -------------------- 🔴model-viewer 読み込み進捗検知 --------------------

  modelViewer.addEventListener('progress', (event) => {
    progressBar.style.width = `${(event.detail.totalProgress * 100) / 2}%`;

    if (event.detail.totalProgress >= 0.9) {
      progressBar.style.width = '50%';
      progressBar.classList.add('hide');
    }
  });

  // -------------------- 🔴model-viewer 読み込み完了検知 --------------------

  modelViewer.addEventListener('load', () => {
    // resetViewerStateForNewModel();

    // 「Four/Two」判定して camera-target をセット
    const srcNow = modelViewer.src || modelViewer.getAttribute('src') || '';
    applyCameraTargetBySrc(srcNow);

    // model-viewerの属性を保存
    captureInitialForCurrentModel();

    // -------------------- 🔴読み込み後の処理 --------------------
    // Dimensionsの線のコンテナを非表示（初期値）
    if (dimensionLineContainer) dimensionLineContainer.style.display = 'none';

    // -------------------- 🔴GLBファイルの情報取得 --------------------

    // アニメーション名の取得
    // availableAnimations はアニメーション名の配列を返す
    const animations = modelViewer.availableAnimations;
    console.log(`🔴 Name of Animations:${animations[0]}`);
    if (animations[0] === undefined) {
      console.log(`🔴 なし`);
      wrapperViewer.classList.add('noFlap');
    }

    // マテリアル全リストを取得
    const materials = modelViewer.model.materials;

    // 事前にsrcからベース色（本体色）を決めておく（forEachの外）
    const srcStr = modelViewer.src || modelViewer.getAttribute('src') || '';
    const baseColorHex = srcStr.includes('blue')
      ? '252f37'
      : srcStr.includes('green')
      ? '32342a'
      : null;

    // ベース色を当てていい素材か（上書き禁止の素材は除外）
    function isBaseColorTarget(matName) {
      const n = (matName || '').toLowerCase();

      // 個別ルールがある素材は除外（＝ここは後段の個別処理に任せる）
      if (n === 'aluminum') return false;
      if (n.includes('plate')) return false;
      if (n.includes('flap')) return false;
      if (n.includes('highlights')) return false;

      // それ以外はベース側として扱う（必要ならここで絞り込み可能）
      return true;
    }

    // 各マテリアルに対してループ処理
    materials.forEach((material, index) => {
      const matName = material.name;

      //  src(blue/green) に応じて「ベース用素材だけ」に色を当てる
      // - Aluminum / plate / Flap / highlights は後段の個別ルールに任せる
      if (baseColorHex && isBaseColorTarget(matName)) {
        const baseColor = hexToRgba(baseColorHex);
        applySpecificColorStyle(material, baseColor);
      }

      // 特定のパーツ（例: Aluminum）に個別設定
      if (matName === 'Aluminum') {
        // const colorArray = hexToRgba("6a6b6f");
        const colorArray = hexToRgba('c8c8c8');

        // ▼ 反射の設定を変更

        // Metallic（金属度）を設定 [0.0 ～ 1.0]
        // 0.0 = プラスチック・陶器風
        // 1.0 = 金属風

        // Roughness（粗さ）を設定 [0.0 ～ 1.0]
        // 0.0 = 超ツルツル（反射最強）
        // 0.5 = 半光沢
        // 1.0 = ツヤ消し（反射なし）
        material.pbrMetallicRoughness.setMetallicFactor(1);
        material.pbrMetallicRoughness.setRoughnessFactor(0.2);
        // material.pbrMetallicRoughness.setRoughnessFactor(0);
        applySpecificColorStyle(material, colorArray);
      }

      if (matName.includes('plate')) {
        const colorArray = hexToRgba('777777');
        applySpecificColorStyle(material, colorArray);
      }

      if (matName.includes('Flap')) {
        const colorArray = hexToRgba('c8c8c8');
        material.pbrMetallicRoughness.setMetallicFactor(1);
        material.pbrMetallicRoughness.setRoughnessFactor(0.2);
        applySpecificColorStyle(material, colorArray);
      }

      if (matName.includes('highlights')) {
        const colorArray = hexToRgba('ffffff');
        applySpecificColorStyle(material, colorArray);
        if (matName.includes('blue')) {
          const colorArray = hexToRgba('829bb4');
          applySpecificColorStyle(material, colorArray);
        }
        if (matName.includes('green')) {
          const colorArray = hexToRgba('8B8A7B');
          applySpecificColorStyle(material, colorArray);
        }
      }

      if (matName.includes('Flap_30_bake')) {
        wrapperViewer.classList.add('flap30');
      }
      if (matName.includes('Flap_45_bake')) {
        wrapperViewer.classList.add('flap45');
      }
    });

    // オブジェクト毎にカラーを設定
    function applySpecificColorStyle(material, colorArray) {
      material.pbrMetallicRoughness.setBaseColorFactor(colorArray);
    }

    // Flapアニメーションを初期位置にセット
    function setAnimationReset() {
      // 【重要】強制的に開始位置(0秒)へ戻す
      modelViewer.pause();
      modelViewer.currentTime = 0;
      modelViewer.timeScale = 1;
    }

    // Flapボタン関連の表示関数
    function setBtnVisibility(boolean) {
      if (boolean) {
        btnOpen.style.display = 'flex';
        btnHide.style.display = 'flex';

        // ボタンが少ない時、Refreshボタンを非アクティブに
        btnRefresh.style.width = '28px';
        // btnRefresh.classList.remove("active");
      } else {
        btnOpen.style.display = 'none';
        btnHide.style.display = 'none';

        // ボタンが少ない時、Refreshボタンをアクティブに
        btnRefresh.style.width = '82px';
        // btnRefresh.classList.add("active");
      }
    }

    // Flapボタン関連の初期状態状態管理（アニメーション名の有無で表示制御）
    if (animations.length > 0) {
      setBtnVisibility(true);

      // アニメーションの初期位置へリセット
      setAnimationReset();
    } else {
      setBtnVisibility(false);
    }

    // -------------------------------------- Dimensions 非表示（初期化）
    setDimensionVisibility(false);
    dim.forEach((element) => {
      element.style.display = 'none';
    });

    // ----------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------

    const center = modelViewer.getBoundingBoxCenter();
    const size = modelViewer.getDimensions();
    const x2 = size.x / 2;
    const y2 = size.y / 2;
    const z2 = size.z / 2;

    // 小数第1位までの場合はそのまま表示、整数の場合は小数点なし
    function formatNumber(num) {
      const fixed = num.toFixed(1); // 小数点1桁に丸める
      return fixed.endsWith('.0') ? fixed.slice(0, -2) : fixed;
    }

    // 🔴ラベル W 手前
    modelViewer.querySelector(
      'button[slot="hotspot-dim-Y-Z"]'
    ).textContent = `W: ${formatNumber(size.x * 100)}cm`;
    // 🔴ラベル W 奥
    modelViewer.querySelector(
      'button[slot="hotspot-dim-Y+Z"]'
    ).textContent = `W: ${formatNumber(size.x * 100)}cm`;
    // 🔴ラベル D 左
    modelViewer.querySelector(
      'button[slot="hotspot-dim-X-Y"]'
    ).textContent = `D: ${formatNumber(size.z * 100)}cm`;
    // 🔴ラベル D 右
    modelViewer.querySelector(
      'button[slot="hotspot-dim+X-Y"]'
    ).textContent = `D: ${formatNumber(size.z * 100)}cm`;
    // 🔴ラベル H 左
    modelViewer.querySelector(
      'button[slot="hotspot-dim-X-Z"]'
    ).textContent = `H: ${formatNumber(size.y * 100)}cm`;
    // 🔴ラベル H 右
    modelViewer.querySelector(
      'button[slot="hotspot-dim+X-Z"]'
    ).textContent = `H: ${formatNumber(size.y * 100)}cm`;

    const offsetLabel = 2;
    // Hotspotからのオフセットの距離 m（メートル）
    const offsetDistance = 0.18;
    const offsetDistanceT = 0.05;

    // 🔴ラベルx,y,z座標 W 手前
    modelViewer.updateHotspot({
      name: 'hotspot-dim-Y-Z',
      position: `${center.x} ${0} ${center.z + z2 * offsetLabel}`,
    });
    // 🔴ラベルx,y,z座標 W 奥
    modelViewer.updateHotspot({
      name: 'hotspot-dim-Y+Z',
      position: `${center.x} ${0} ${center.z + z2 * -offsetLabel}`,
    });
    // 🔴ラベルx,y,z座標 D 左
    modelViewer.updateHotspot({
      name: 'hotspot-dim-X-Y',
      position: `${center.x - x2 - offsetDistance} ${center.y - y2} ${
        center.z
      }`, // ラベルの位置調整 X
    });
    // 🔴ラベルx,y,z座標 D 右
    modelViewer.updateHotspot({
      name: 'hotspot-dim+X-Y',
      position: `${center.x + x2 + offsetDistance} ${center.y - y2} ${
        center.z
      }`, // ラベルの位置調整 X
    });
    // 🔴ラベルx,y,z座標 H 左
    modelViewer.updateHotspot({
      name: 'hotspot-dim-X-Z',
      position: `${center.x - x2} ${center.y} ${
        center.z - z2 - offsetDistance
      }`, // ラベルの位置調整 Z
    });
    // 🔴ラベルx,y,z座標 H 右
    modelViewer.updateHotspot({
      name: 'hotspot-dim+X-Z',
      position: `${center.x + x2} ${center.y} ${
        center.z - z2 - offsetDistance
      }`, // ラベルの位置調整 Z
    });
    // （1）
    modelViewer.updateHotspot({
      name: 'hotspot-dot+X+Y-Z',
      position: `${center.x + x2} ${center.y + y2} ${center.z - z2}`,
    });
    // （1B）
    modelViewer.updateHotspot({
      name: 'hotspot-dot+X+Y-Z+OFFSET-Z',
      position: `${center.x + x2} ${center.y + y2} ${
        center.z - z2 - offsetDistance
      }`,
    });
    // （1BT-1）
    modelViewer.updateHotspot({
      name: 'hotspot-dot+X+Y-Z+OFFSET-Z+T',
      position: `${center.x + x2} ${center.y + y2} ${
        center.z - z2 - offsetDistance - offsetDistanceT
      }`,
    });
    // （1BT-2）
    modelViewer.updateHotspot({
      name: 'hotspot-dot+X+Y-Z+OFFSET-Z-T',
      position: `${center.x + x2} ${center.y + y2} ${
        center.z - z2 - offsetDistance + offsetDistanceT
      }`,
    });
    // （2）
    modelViewer.updateHotspot({
      name: 'hotspot-dot-X-Y+Z',
      position: `${center.x - x2} ${center.y - y2} ${center.z + z2}`,
    });
    // （2A）
    modelViewer.updateHotspot({
      name: 'hotspot-dot-X-Y+Z+OFFSET-X',
      position: `${center.x - x2 - offsetDistance} ${center.y - y2} ${
        center.z + z2
      }`, // ラベルの位置調整 X = -0.2
    });
    // （2AT-1）
    modelViewer.updateHotspot({
      name: 'hotspot-dot-X-Y+Z+OFFSET-X-T',
      position: `${center.x - x2 - offsetDistance - offsetDistanceT} ${
        center.y - y2
      } ${center.z + z2}`, // ラベルの位置調整 X = -0.2
    });
    // （2AT-2）
    modelViewer.updateHotspot({
      name: 'hotspot-dot-X-Y+Z+OFFSET-X+T',
      position: `${center.x - x2 - offsetDistance + offsetDistanceT} ${
        center.y - y2
      } ${center.z + z2}`, // ラベルの位置調整 X = -0.2
    });
    // （2B）
    modelViewer.updateHotspot({
      name: 'hotspot-dot-X-Y+Z+OFFSET+Z',
      position: `${center.x - x2} ${center.y - y2} ${
        center.z + z2 + offsetDistance
      }`,
    });
    // （2BT-1）
    modelViewer.updateHotspot({
      name: 'hotspot-dot-X-Y+Z+OFFSET+Z+T',
      position: `${center.x - x2} ${center.y - y2} ${
        center.z + z2 + offsetDistance - offsetDistanceT
      }`,
    });
    // （2BT-2）
    modelViewer.updateHotspot({
      name: 'hotspot-dot-X-Y+Z+OFFSET+Z-T',
      position: `${center.x - x2} ${center.y - y2} ${
        center.z + z2 + offsetDistance + offsetDistanceT
      }`,
    });
    // （3）
    modelViewer.updateHotspot({
      name: 'hotspot-dot+X-Y-Z',
      position: `${center.x + x2} ${center.y - y2} ${center.z - z2}`,
    });
    // （3B）
    modelViewer.updateHotspot({
      name: 'hotspot-dot+X-Y-Z+OFFSET-Z',
      position: `${center.x + x2} ${center.y - y2} ${
        center.z - z2 - offsetDistance
      }`,
    });
    // （3BT-1）
    modelViewer.updateHotspot({
      name: 'hotspot-dot+X-Y-Z+OFFSET-Z-T',
      position: `${center.x + x2} ${center.y - y2} ${
        center.z - z2 - offsetDistance - offsetDistanceT
      }`,
    });
    // （3BT-2）
    modelViewer.updateHotspot({
      name: 'hotspot-dot+X-Y-Z+OFFSET-Z+T',
      position: `${center.x + x2} ${center.y - y2} ${
        center.z - z2 - offsetDistance + offsetDistanceT
      }`,
    });
    // （3A）
    modelViewer.updateHotspot({
      name: 'hotspot-dot+X-Y-Z+OFFSET+X',
      position: `${center.x + x2 + offsetDistance} ${center.y - y2} ${
        center.z - z2
      }`, // ラベルの位置調整 X = +0.2
    });
    // （3AT-1）
    modelViewer.updateHotspot({
      name: 'hotspot-dot+X-Y-Z+OFFSET+X-T',
      position: `${center.x + x2 + offsetDistance - offsetDistanceT} ${
        center.y - y2
      } ${center.z - z2}`, // ラベルの位置調整 X = -0.2
    });
    // （3AT-2）
    modelViewer.updateHotspot({
      name: 'hotspot-dot+X-Y-Z+OFFSET+X+T',
      position: `${center.x + x2 + offsetDistance + offsetDistanceT} ${
        center.y - y2
      } ${center.z - z2}`, // ラベルの位置調整 X = +0.2
    });
    // （4）
    modelViewer.updateHotspot({
      name: 'hotspot-dot-X+Y+Z',
      position: `${center.x - x2} ${center.y + y2} ${center.z + z2}`,
    });
    // （5）
    modelViewer.updateHotspot({
      name: 'hotspot-dot+X-Y+Z',
      position: `${center.x + x2} ${center.y - y2} ${center.z + z2}`,
    });
    // （5A）
    modelViewer.updateHotspot({
      name: 'hotspot-dot+X-Y+Z+OFFSET+X',
      position: `${center.x + x2 + offsetDistance} ${center.y - y2} ${
        center.z + z2
      }`,
    });
    // （5AT-1）
    modelViewer.updateHotspot({
      name: 'hotspot-dot+X-Y+Z+OFFSET+X-T',
      position: `${center.x + x2 + offsetDistance - offsetDistanceT} ${
        center.y - y2
      } ${center.z + z2}`,
    });
    // （5AT-2）
    modelViewer.updateHotspot({
      name: 'hotspot-dot+X-Y+Z+OFFSET+X+T',
      position: `${center.x + x2 + offsetDistance + offsetDistanceT} ${
        center.y - y2
      } ${center.z + z2}`,
    });
    // （5B）
    modelViewer.updateHotspot({
      name: 'hotspot-dot+X-Y+Z+OFFSET+Z',
      position: `${center.x + x2} ${center.y - y2} ${
        center.z + z2 + offsetDistance
      }`,
    });
    // （5BT-1）
    modelViewer.updateHotspot({
      name: 'hotspot-dot+X-Y+Z+OFFSET+Z-T',
      position: `${center.x + x2} ${center.y - y2} ${
        center.z + z2 + offsetDistance - offsetDistanceT
      }`,
    });
    // （5BT-2）
    modelViewer.updateHotspot({
      name: 'hotspot-dot+X-Y+Z+OFFSET+Z+T',
      position: `${center.x + x2} ${center.y - y2} ${
        center.z + z2 + offsetDistance + offsetDistanceT
      }`,
    });
    // （6）
    modelViewer.updateHotspot({
      name: 'hotspot-dot-X+Y-Z',
      position: `${center.x - x2} ${center.y + y2} ${center.z - z2}`,
    });
    // （6B）
    modelViewer.updateHotspot({
      name: 'hotspot-dot-X+Y-Z+OFFSET-Z',
      position: `${center.x - x2} ${center.y + y2} ${
        center.z - z2 - offsetDistance
      }`,
    });
    // （6BT-1）
    modelViewer.updateHotspot({
      name: 'hotspot-dot-X+Y-Z+OFFSET-Z+T',
      position: `${center.x - x2} ${center.y + y2} ${
        center.z - z2 - offsetDistance + offsetDistanceT
      }`,
    });
    // （6BT-2）
    modelViewer.updateHotspot({
      name: 'hotspot-dot-X+Y-Z+OFFSET-Z-T',
      position: `${center.x - x2} ${center.y + y2} ${
        center.z - z2 - offsetDistance - offsetDistanceT
      }`,
    });
    // （7）
    modelViewer.updateHotspot({
      name: 'hotspot-dot+X+Y+Z',
      position: `${center.x + x2} ${center.y + y2} ${center.z + z2}`,
    });
    // （7B）
    modelViewer.updateHotspot({
      name: 'hotspot-dot+X+Y+Z+OFFSET+Z',
      position: `${center.x + x2} ${center.y + y2} ${
        center.z + z2 + offsetDistance
      }`,
    });
    // （8）
    modelViewer.updateHotspot({
      name: 'hotspot-dot-X-Y-Z',
      position: `${center.x - x2} ${center.y - y2} ${center.z - z2}`,
    });
    // （8A）
    modelViewer.updateHotspot({
      name: 'hotspot-dot-X-Y-Z+OFFSET-X',
      position: `${center.x - x2 - offsetDistance} ${center.y - y2} ${
        center.z - z2
      }`,
    });
    // （8AT-1）
    modelViewer.updateHotspot({
      name: 'hotspot-dot-X-Y-Z+OFFSET-X-T',
      position: `${center.x - x2 - offsetDistance - offsetDistanceT} ${
        center.y - y2
      } ${center.z - z2}`,
    });
    // （8AT-2）
    modelViewer.updateHotspot({
      name: 'hotspot-dot-X-Y-Z+OFFSET-X+T',
      position: `${center.x - x2 - offsetDistance + offsetDistanceT} ${
        center.y - y2
      } ${center.z - z2}`,
    });
    // （8B）
    modelViewer.updateHotspot({
      name: 'hotspot-dot-X-Y-Z+OFFSET-Z',
      position: `${center.x - x2} ${center.y - y2} ${
        center.z - z2 - offsetDistance
      }`,
    });
    // （8BT-1）
    modelViewer.updateHotspot({
      name: 'hotspot-dot-X-Y-Z+OFFSET+Z+T',
      position: `${center.x - x2} ${center.y - y2} ${
        center.z - z2 - offsetDistance - offsetDistanceT
      }`,
    });
    // （8BT-2）
    modelViewer.updateHotspot({
      name: 'hotspot-dot-X-Y-Z+OFFSET+Z-T',
      position: `${center.x - x2} ${center.y - y2} ${
        center.z - z2 - offsetDistance + offsetDistanceT
      }`,
    });

    renderSVG();

    // modelViewer.addEventListener('camera-change', renderSVG);

    // camera-change の増殖防止（src切替でloadが何度も走るため）
    if (onCameraChangeBound) {
      modelViewer.removeEventListener('camera-change', onCameraChangeBound);
    }
    onCameraChangeBound = renderSVG;
    modelViewer.addEventListener('camera-change', onCameraChangeBound);

    // updateNameFromModelViewerSrc(modelViewer);

    // -------------------- 🔴読み込み後の処理 --------------------

    //  切替終了：表示を戻す
    overlay?.classList.add('hide');
    modelViewer.classList.remove('is-swapping');

    // 最後に1回だけ
    if (typeof modelViewer.jumpCameraToGoal === 'function') {
      modelViewer.jumpCameraToGoal();
    }

    hasInitialLoaded = true;
  });

  // -------------------------------------- ARボタン
  btnAR.addEventListener('click', () => {
    modelViewer.activateAR();
  });

  // -------------------------------------- Fullscreen ボタン
  btnFullscreen.addEventListener('click', () => {
    const fullscreenActive = modelViewer.classList.contains('active');

    if (fullscreenActive) {
      document.exitFullscreen();
    } else {
      modelViewer.requestFullscreen();
    }
  });

  // omi追加（fullscreenchangさしかえ）
  document.addEventListener('fullscreenchange', () => {
    const assets = getViewerAssets();
    const isFs = !!document.fullscreenElement;

    if (btnFullscreenExit) {
      if (isFs) {
        btnFullscreenExit.src =
          assets?.fullscreenOn || defaultFullscreenIconSrc;
      } else {
        btnFullscreenExit.src =
          assets?.fullscreenOff || defaultFullscreenIconSrc;
      }
    }

    if (document.fullscreenElement) {
      btnFullscreen.classList.add('selected');
      modal?.classList.add('is-fullscreen');

      setFullscreenUI(true);

      // Fullscreenアイコンの変更（Shopify asset）
      if (assets?.fullscreenOn) btnFullscreenExit.src = assets.fullscreenOn;

      dim.forEach((element) => {
        element.style.fontSize = '0.85rem';
      });

      [
        modelViewer,
        wrapperButton,
        wrapperButtonOption,
        btnFullscreen,
        btnRefresh,
      ].forEach((el) => el.classList.add('active'));
      textProductName.forEach((el) => el.classList.add('active'));
    } else {
      btnFullscreen.classList.remove('selected');
      modal?.classList.remove('is-fullscreen');

      setFullscreenUI(false);

      // Fullscreenアイコンの変更（Shopify asset）
      if (assets?.fullscreenOff) btnFullscreenExit.src = assets.fullscreenOff;

      dim.forEach((element) => {
        element.style.fontSize = '0.7rem';
      });

      [
        modelViewer,
        wrapperButton,
        wrapperButtonOption,
        btnFullscreen,
        btnRefresh,
      ].forEach((el) => el.classList.remove('active'));
      textProductName.forEach((el) => el.classList.remove('active'));
    }
  });

  // ✅ 追加: fullscreen UIの表示/非表示を強制的に切り替える
  function setFullscreenUI(isFs) {
    // ここは「fullscreen時に見せたい/隠したい」に合わせて調整OK
    if (wrapperButton) wrapperButton.style.display = isFs ? 'flex' : '';
    if (wrapperButtonOption)
      wrapperButtonOption.style.display = isFs ? 'flex' : '';
    if (btnClose) btnClose.style.display = isFs ? 'flex' : ''; // fullscreen時に閉じる導線を出す
  }

  // -------------------------------------- Open the Flap && Hide Flap
  //
  //パーツの表示・非表示を切り替える共通内部関数
  // @param {boolean} isVisible - 表示ならtrue, 非表示ならfalse
  //
  function updatePartsVisibility(isVisible, flap30, flap45, screw, spacer) {
    const is30 = wrapperViewer.classList.contains('flap30');
    const is45 = wrapperViewer.classList.contains('flap45');

    const targetParts = [];
    if (is30 || is45) {
      targetParts.push(screw, spacer);
      if (is30) targetParts.push(flap30);
      if (is45) targetParts.push(flap45);
    }

    // ✅ null を除外
    targetParts.filter(Boolean).forEach((part) => {
      part.pbrMetallicRoughness.setBaseColorFactor(
        isVisible ? [1, 1, 1, 1] : [1, 1, 1, 0]
      );
      part.setAlphaMode(isVisible ? 'OPAQUE' : 'BLEND');
    });
  }

  // モデル内のFlapを非表示にする
  function hidePart(flap30, flap45, screw, spacer) {
    // ボタンにクラス名追加
    btnHide.classList.add('selected');

    // Flapの位置を初期化する
    modelViewer.pause();
    modelViewer.timeScale = -1;
    modelViewer.currentTime = 0;
    modelViewer.play({
      repetitions: 1, // repetitions: 1 繰り返し回数
    });

    updatePartsVisibility(false, flap30, flap45, screw, spacer);
  }

  // モデル内のFlapを表示する
  function showPart(flap30, flap45, screw, spacer) {
    // ボタンからクラス名削除
    btnHide.classList.remove('selected');

    updatePartsVisibility(true, flap30, flap45, screw, spacer);
  }

  function runRefresh() {
    if (!initial) return; // ✅ 初期値がまだ取れてない時は何もしない

    // ✅ カメラを初期値へ
    modelViewer.cameraOrbit = initial.cameraOrbit;
    modelViewer.fieldOfView = initial.fieldOfView;

    if (initial.cameraTarget) modelViewer.cameraTarget = initial.cameraTarget;

    // ✅ 寸法OFF
    setDimensionVisibility(false);
    btnDimensions.classList.remove('selected');

    // ✅ flapがある場合の復帰
    if (!wrapperViewer.classList.contains('noFlap')) {
      modelViewer.pause();
      modelViewer.timeScale = -1;
      modelViewer.play({ repetitions: 1 });

      btnOpenIconOverlay('Close');
      btnOpen.classList.remove('selected');
      btnHide.classList.remove('selected');

      const materialFlap30 =
        modelViewer.model.getMaterialByName('Flap_30_bake');
      const materialFlap45 =
        modelViewer.model.getMaterialByName('Flap_45_bake');
      const materialSpacer = modelViewer.model.getMaterialByName('Spacer');
      const materialScrew =
        modelViewer.model.getMaterialByName('Screw-of-flap');

      btnHideIconOverlay('Show');
      showPart(materialFlap30, materialFlap45, materialScrew, materialSpacer);

      btnOpen.style.opacity = 1;
      btnOpen.style.pointerEvents = 'auto';
    }
  }

  // -------------------------------------- Dimensions 表示非表示
  function setDimensionVisibility(visible) {
    const dimensionLineContainer = modelViewer.querySelector(
      '.dimensionLineContainer'
    );
    const dimElements = [
      ...modelViewer.querySelectorAll('.button'),
      modelViewer.querySelector('#dimLines'),
    ].filter(Boolean);
    const dim = document.querySelectorAll('.dim');

    if (visible) {
      if (dimensionLineContainer)
        dimensionLineContainer.style.display = 'block';
      dimElements.forEach((el) => el.classList.remove('hide'));
      dim.forEach((el) => (el.style.display = 'block'));
    } else {
      if (dimensionLineContainer) dimensionLineContainer.style.display = 'none';
      dimElements.forEach((el) => el.classList.add('hide'));
      // dim は初期化で消してるならここは任意
    }
  }
  // -------------------------------------- Flap アニメーション再生
  function actionOpen() {
    // 再生中なら何もしない（連打防止）※必要に応じて外してもOK
    if (!modelViewer.loaded || !modelViewer.paused) return;

    const duration = modelViewer.duration;
    const currentTime = modelViewer.currentTime;

    // 判定ロジックの修正:
    // 「現在位置がほぼ最後(残り0.05秒以下)」なら逆再生
    // それ以外（0秒地点や途中）なら順再生
    // ※ duration が 0 の場合のエラー回避も念のため入れています
    const isAtEnd = duration > 0 && currentTime >= duration - 0.05;

    if (isAtEnd) {
      // ボタンからクラス名削除
      btnOpen.classList.remove('selected');

      modelViewer.pause();

      // --- 逆再生 (戻す) ---
      modelViewer.timeScale = -1;
      // modelViewer.currentTime = modelViewer.duration;
      modelViewer.play({
        repetitions: 1, // repetitions: 1 繰り返し回数
      });

      btnOpenIconOverlay('Close');
    } else {
      // ボタンにクラス名追加
      btnOpen.classList.add('selected');

      // --- 順再生 (進む) ---
      modelViewer.timeScale = 1;
      modelViewer.play({
        repetitions: 1, // repetitions: 1 繰り返し回数
      });

      btnOpenIconOverlay('Open'); //
    }
  }

  function actionHide() {
    if (!modelViewer.model) return;

    const materialFlap30 = modelViewer.model.getMaterialByName('Flap_30_bake');
    const materialFlap45 = modelViewer.model.getMaterialByName('Flap_45_bake');
    const materialSpacer = modelViewer.model.getMaterialByName('Spacer');
    const materialScrew = modelViewer.model.getMaterialByName('Screw-of-flap');

    // ✅ flapが無いモデルなら何もしない（UI的にはボタンを隠す方が良い）
    if (!materialSpacer && !materialScrew && !materialFlap30 && !materialFlap45)
      return;

    if (!btnHide.classList.contains('selected')) {
      // アイコンの切り替え
      btnHideIconOverlay('Hide');
      // setAnimationReset();

      // Flapを隠す
      hidePart(materialFlap30, materialFlap45, materialScrew, materialSpacer);

      // btnOpen.style.display = "none";
      btnOpen.style.opacity = 0.3;
      btnOpen.style.pointerEvents = 'none';
      if (btnOpen.classList.contains('selected')) {
        btnOpenIconOverlay('Hide');
      }
    } else {
      // アイコンの切り替え
      btnHideIconOverlay('Show');

      // Flapを表示
      showPart(materialFlap30, materialFlap45, materialScrew, materialSpacer);

      // btnOpen.style.display = "flex";
      btnOpen.style.opacity = 1;
      btnOpen.style.pointerEvents = 'auto';
    }
  }

  function closestFromEvent(e, selector) {
    const path = e.composedPath ? e.composedPath() : [];
    for (const node of path) {
      if (node instanceof Element && node.matches(selector)) return node;
      if (node instanceof Element) {
        const hit = node.closest?.(selector);
        if (hit) return hit;
      }
    }
    return null;
  }

  document.addEventListener(
    'click',
    (e) => {
      const hitDimensions = closestFromEvent(e, '.viewer-ui-dimensions');
      const hitHide = closestFromEvent(e, '.viewer-ui-hide');
      const hitOpen = closestFromEvent(e, '.viewer-ui-open');
      const hitRefresh = closestFromEvent(e, '.viewer-ui-refresh');

      if (hitDimensions) {
        const dimensionLineContainer = modelViewer.querySelector(
          '.dimensionLineContainer'
        );
        const dimElements = [
          ...modelViewer.querySelectorAll('.button'),
          modelViewer.querySelector('#dimLines'),
        ].filter(Boolean);

        const dim = modelViewer.querySelectorAll('.dim');

        const isOn =
          dimensionLineContainer?.style.display === 'none' ||
          !dimensionLineContainer?.style.display;

        hitDimensions.classList.toggle('selected', isOn);

        if (dimensionLineContainer)
          dimensionLineContainer.style.display = isOn ? 'block' : 'none';
        dimElements.forEach((el) => el.classList.toggle('hide', !isOn));
        dim.forEach((el) => (el.style.display = isOn ? 'block' : 'none'));
        return;
      }

      if (hitHide) {
        actionHide();
        return;
      }
      if (hitOpen) {
        actionOpen();
        return;
      }
      if (hitRefresh) {
        runRefresh();
        return;
      }
    },
    true
  );
  function btnOpenIconOverlay(state) {
    if (state == 'Open') {
      btnOpenText.textContent = 'Close Flap';
      btnOpenIconOn.classList.add('toggle');
      btnOpenIconOff.classList.add('toggle');
    } else {
      btnOpenText.textContent = 'Open Flap';
      btnOpenIconOn.classList.remove('toggle');
      btnOpenIconOff.classList.remove('toggle');
    }
  }

  function btnHideIconOverlay(state) {
    if (state == 'Hide') {
      btnHideText.textContent = 'Show Flap';
      btnHideIconOn.classList.add('toggle');
      btnHideIconOff.classList.add('toggle');
    } else {
      btnHideText.textContent = 'Hide Flap';
      btnHideIconOn.classList.remove('toggle');
      btnHideIconOff.classList.remove('toggle');
    }
  }

  btnClose?.addEventListener('click', () => {
    // fullscreen中なら先に抜ける
    if (document.fullscreenElement) document.exitFullscreen();

    // ✅ モーダルの閉じ方（どっちかに合わせて）
    // <dialog> の場合
    if (typeof modal.close === 'function') modal.close();
  });
});

// 商品名の登録（初回 or glb切替のたびに呼ぶ）
function setProductName(modelViewer) {
  const base = modelViewer?.dataset?.productnameBase || '';
  const name = base || modelViewer?.dataset?.productname || '';
  document.querySelectorAll('.product-name').forEach((el) => {
    el.textContent = name;
  });
}

/* =========================================================
   ✅ User Story 用：カメラ位置ずれ対策（Sceneに影響なし）
   SceneのJSはそのまま、下に “追記” してください
========================================================= */
(() => {
  // ▼ Sceneで使ってる関数を “そのまま流用” できるように同名で用意
  // すでに上で定義済みなら、この関数は消してOK（重複させない）
  function applyCameraBySrc(mv, src, opts = {}) {
    if (!mv || !src) return;

    const s = String(src);
    const isFour = /four/i.test(s);

    const cameraTargetTwo = '0m 0.4m 0m';
    const cameraTargetFour = '0m 0.73m 0m';

    const cameraOrbitTwo = '20deg 86deg 105%';
    const cameraOrbitFour = cameraOrbitTwo;

    mv.setAttribute(
      'camera-target',
      isFour ? cameraTargetFour : cameraTargetTwo
    );
    mv.setAttribute('camera-orbit', isFour ? cameraOrbitFour : cameraOrbitTwo);

    try {
      mv.cameraTarget = mv.getAttribute('camera-target');
      mv.cameraOrbit = mv.getAttribute('camera-orbit');
    } catch (e) {}

    const shouldJump = opts.jump ?? mv.loaded;
    if (shouldJump && typeof mv.jumpCameraToGoal === 'function') {
      try {
        mv.jumpCameraToGoal();
      } catch (e) {}
    }
  }

  // ✅ User Story の model-viewer を安全に初期化
  function initUserStoryViewer(mv) {
    if (!mv || mv.__userstoryCameraFixed) return;
    mv.__userstoryCameraFixed = true;

    let lastSrc = mv.src || mv.getAttribute('src') || '';
    let pendingSrc = '';

    // load：最終確定（古いloadを弾きつつ、最後にjump）
    const onLoad = () => {
      const src = mv.src || mv.getAttribute('src') || '';

      // 予約してるsrcがあるのに違うloadが来たら無視（遅延load対策）
      if (pendingSrc && src !== pendingSrc) return;
      pendingSrc = '';

      // load後にもう一回同期（最終確定）
      applyCameraBySrc(mv, src, { jump: false });

      // 最後に1回だけ jump
      if (typeof mv.jumpCameraToGoal === 'function') {
        try {
          mv.jumpCameraToGoal();
        } catch (e) {}
      }
    };

    mv.addEventListener('load', onLoad);

    // src変更監視：load前にカメラを先当て（これが効く）
    const mo = new MutationObserver(() => {
      const newSrc = mv.src || mv.getAttribute('src') || '';
      if (!newSrc || newSrc === lastSrc) return;

      lastSrc = newSrc;
      pendingSrc = newSrc;

      // ★重要：load前に先当て（古いTwo表示/ズレ防止）
      applyCameraBySrc(mv, newSrc, { jump: false });
    });
    mo.observe(mv, { attributes: true, attributeFilter: ['src'] });

    // 初回も一応当てる（初期表示がズレるケース対策）
    if (lastSrc) applyCameraBySrc(mv, lastSrc, { jump: false });
  }

  // ✅ 探す（IDを付けたので “UserStoryModelViewerだけ” を狙える）
  function boot() {
    const mv =
      document.getElementById('modelViewer') ||
      document.querySelector('[data-userstory-viewer] model-viewer'); // 保険

    if (mv) initUserStoryViewer(mv);
  }

  // 初回
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Shopify セクション差し替え対策（User Story が動的に出る場合）
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('shopify:section:reorder', boot);
})();
